import { useEffect } from 'react';
import ScrollReveal from 'scrollreveal';
import heroImg from '../../images/hero_img.jpg'

const LandingPage = () => {
    useEffect(()=>{

        const scroll = ScrollReveal({
            origin: "top",
            distance: "8rem",
            duration: 2000,
            reset: true
        })

        scroll.reveal(".home__title", {})
        scroll.reveal(".hero__button", {delay: 600})
        scroll.reveal("#home_img",{delay: 300})
        scroll.reveal(".social-item",{ interval: 400})
    },[])

    return (
        <section id='hero'>
            <div className='hero container' >
                <div className="home__title">
                    <h1>
                        Hi, I'm Solomon <span></span>
                    </h1>
                    <h1>
                        Front-End Developer <span></span>
                    </h1>
                    <div className="hero__button">
                        <a href='#projects' type='button' className='btn'>
                            Portfolio <span></span>
                        </a>
                    </div>
                </div>
                <div className="hero_img">
                    <img id="hero_img" src={heroImg} alt="background" />
                </div>
                <div className='social-icons'>
                    <a
                        href='https://web.facebook.com/S.Njobvu1'
                        target='_blank'
                        rel='noopener noreferrer'
                        className="social-item"
                    >
                        <box-icon
                            size='lg'
                            color='rgba(219, 233, 241, 0.925)'
                            animation='burst-hover'
                            type='logo'
                            name='facebook-circle'
                        ></box-icon>
                    </a>

                    <a
                        href='https://www.linkedin.com/in/solomonnjobvu'
                        target='_blank'
                        rel='noopener noreferrer'
                        className="social-item"
                    >
                        <box-icon
                            size='lg'
                            color='rgba(219, 233, 241, 0.925)'
                            animation='burst-hover'
                            name='linkedin-square'
                            type='logo'
                        ></box-icon>
                    </a>

                    <a
                        href='https://www.instagram.com/namzsolomon'
                        target='_blank'
                        rel='noopener noreferrer'
                        className="social-item"
                    >
                        <box-icon
                            size='lg'
                            color='rgba(219, 233, 241, 0.925)'
                            animation='burst-hover'
                            type='logo'
                            name='instagram'
                        ></box-icon>
                    </a>

                    <a
                        href='https://dev.to/thisissolomon'
                        target='_blank'
                        rel='noopener noreferrer'
                        className="social-item"
                    >
                        <box-icon
                            size='lg'
                            color='rgba(219, 233, 241, 0.925)'
                            animation='burst-hover'
                            type='logo'
                            name='dev-to'
                        ></box-icon>
                    </a>

                    <a
                        href='tel:+260966756508'
                        target='_blank'
                        rel='noopener noreferrer'
                        className="social-item"
                    >
                        <box-icon
                            size='lg'
                            color='rgba(219, 233, 241, 0.925)'
                            animation='burst-hover'
                            name='whatsapp'
                            type='logo'
                        ></box-icon>
                    </a>

                    <a
                        href='https://www.twitter.com/iam_njobvu'
                        target='_blank'
                        rel='noopener noreferrer'
                        className="social-item"
                    >
                        <box-icon
                            size='lg'
                            color='rgba(219, 233, 241, 0.925)'
                            animation='burst-hover'
                            name='twitter'
                            type='logo'
                        ></box-icon>
                    </a>

                    <a
                        href='https://www.github.com/thisis-Solomon'
                        target='_blank'
                        rel='noopener noreferrer'
                        className="social-item"
                    >
                        <box-icon
                            size='lg'
                            color='rgba(219, 233, 241, 0.925)'
                            animation='burst-hover'
                            type='logo'
                            name='github'
                        ></box-icon>
                    </a>
                </div>
            </div>
            <div className='action-scroll'>
                <box-icon
                    size='lg'
                    color='#fff'
                    type='solid'
                    name='down-arrow-circle'
                    animation='fade-down'
                ></box-icon>
            </div>
        </section>
    );
};

export default LandingPage;
